import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import useNavigationFunctions from '~/helper/navigationFunctions'
import useTutorialFunctions from '~/helper/tutorialFunctions'
import { useClickAway } from 'react-use'

import * as S from './styled'

export default function CampaignsTabTooltip({ closeProps, tooltipProps }) {
  const { t } = useTranslation()
  const { setSponsorCurrentTabAction } = useNavigationFunctions()
  const { setTutorialAsInativeAction, openCreateCampaignForTutorialAction } = useTutorialFunctions()

  const ref = useRef(null)

  useClickAway(ref, () => {
    setTutorialAsInativeAction()
  })

  const goToCommunitiesTab = () => {
    setSponsorCurrentTabAction('communities')
  }

  return (
    <S.ComponentContainer {...tooltipProps}>
      <S.TooltipArrow />
      <S.TooltipUserAvatar />
      <S.TooltipContainer ref={ref}>
        <S.CloseButtonContainer {...closeProps}>
          <S.CloseIcon onClick={() => setTutorialAsInativeAction()} />
        </S.CloseButtonContainer>
        <S.Title>{t('sponsorStep2TutorialTitle')}</S.Title>
        <S.Subtitle>{t('sponsorPackagesTabSubtitle')}</S.Subtitle>
        <S.ButtonsContainer>
          <S.BackButton onClick={() => goToCommunitiesTab()}>
            <S.BackButtonText>{t('back')}</S.BackButtonText>
          </S.BackButton>
          <S.NextButton {...closeProps}>
            <S.NextButton onClick={() => openCreateCampaignForTutorialAction()}>
              <S.NextButtonText>{t('next')}</S.NextButtonText>
            </S.NextButton>
          </S.NextButton>
        </S.ButtonsContainer>
      </S.TooltipContainer>
    </S.ComponentContainer>
  )
}
